import { CSSProperties } from "react";

import { Deal } from "@mapmycustomers/shared/types/entity";

import BoardColumn from "@app/component/DnDBoard/types/BoardColumn";
import StageColumn from "@app/scene/deal/type/StageColumn";
import colors from "@app/styles/_colors.module.scss";
import anyColorToHex from "@app/util/colors/anyColorToHex";
import getSemiTransparentColor from "@app/util/colors/getSemiTransparentColor";

export const getColumnStyles = (
  column: BoardColumn<StageColumn, Deal>,
  { dragging, isSource }: { dragging?: boolean; isDestination?: boolean; isSource?: boolean }
): CSSProperties => {
  const isDroppableColumn = dragging && !isSource;
  const activeBorder = isDroppableColumn
    ? `0.125rem dashed ${column.color ? anyColorToHex(column.color) : colors.softSlate}`
    : "none";
  return {
    borderBottom: activeBorder,
    borderLeft: activeBorder,
    borderRight: activeBorder,
    borderTop: `0.25rem solid ${column.color ? anyColorToHex(column.color) : colors.softSlate}`,
  };
};

export const getItemListStyles = (
  column: BoardColumn<StageColumn, Deal>,
  {
    dragging,
    isDestination,
    isSource,
  }: { dragging?: boolean; isDestination?: boolean; isSource?: boolean }
): CSSProperties => {
  let backgroundColor = "inherit";
  if (column.color) {
    backgroundColor =
      !dragging || isSource || isDestination
        ? getSemiTransparentColor(column.color)
        : colors.softGray;
  }
  return {
    backgroundColor,
    padding: dragging ? "0.5rem" : "0.75rem",
  };
};
